module.exports = __webpack_public_path__ + "media/images/panels/panel-2-bonusprogramm-d41f2c9f7fd1761d95804a07a02fb204.jpg";